import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { styled, Typography } from "@mui/material";
import { IndicatorSelection, LayerProperties } from "../../types";
import { LegendItemErrorImageFallBack } from "./error/LegendItemErrorImageFallBack";
import { LegendItemSkeleton } from "../skeletons/LegendItemSkeleton";
import { LegendData } from "./LegendData";
import { useIndicator } from "../../hooks/indicatorHooks";

interface Props {
  config: string;
  selection: IndicatorSelection;
  layerProperties: LayerProperties[];
}

export function LegendLoad(props: Props) {
  const { config, selection, layerProperties } = props;
  const { data: indicator } = useIndicator(
    config,
    selection.indicatorId,
    layerProperties
  );

  if (indicator)
    return (
      <LegendStyles
        className="legend-item"
        key={`legend-styles-${selection.indicatorId}`}
      >
        <Typography variant="subtitle2">{indicator.title}</Typography>
        <Suspense
          key={`legend-${selection.indicatorId}`}
          fallback={<LegendItemSkeleton />}
        >
          <ErrorBoundary
            key={`legend-error-image-${selection.indicatorId}`}
            fallbackRender={(fallbackProps) => (
              <LegendItemErrorImageFallBack
                {...fallbackProps}
                config={config}
                selection={selection}
                indicator={indicator}
                layerProperties={layerProperties}
              />
            )}
          >
            <Suspense
              key={`legend-${selection.indicatorId}`}
              fallback={<LegendItemSkeleton />}
            >
              <LegendData
                config={config}
                layerProperties={layerProperties}
                selection={selection}
              />
            </Suspense>
          </ErrorBoundary>
        </Suspense>
      </LegendStyles>
    );
  return null;
}

const LegendStyles = styled("div")`
  .error-icon {
    max-width: 12px;
    max-height: 12px;
  }
`;
